import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsProductService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(available) {
    let url = `/wmsAddress/${this.idconta}`

    if (available) {
      url += `?available=${available}`
    }

    const response = await apinode.get(url)

    return response.data
  }

  async getAllBySKU(sku) {
    const response = await apinode.get(
      `/wmsAddress/product/${this.idconta}/${sku}`,
    )

    return response.data
  }

  async getBySearch({
    codendereco,
    rua,
    deposito,
    apto,
    nivel,
    predio,
    tipoender,
    situacao,
  }) {
    let url = `/wmsAddress/search/${this.idconta}`

    const urlParams = unifyParams(url, [
      {
        key: 'codendereco',
        value: codendereco,
      },
      {
        key: 'deposito',
        value: deposito,
      },
      {
        key: 'rua',
        value: rua,
      },
      {
        key: 'predio',
        value: predio,
      },

      {
        key: 'nivel',
        value: nivel,
      },

      {
        key: 'apto',
        value: apto,
      },
      {
        key: 'tipoender',
        value: tipoender,
      },
      {
        key: 'situacao',
        value: situacao,
      },
    ])

    const response = await apinode.get(urlParams)

    return response.data
  }

  async searchBySKU({
    sku,
    codendereco,
    rua,
    deposito,
    apto,
    nivel,
    predio,
    tipoender,
    situacao,
  }) {
    let url = `/wmsAddress/product/search/${this.idconta}`

    const urlParams = unifyParams(url, [
      {
        key: 'sku',
        value: sku,
      },
      {
        key: 'codendereco',
        value: codendereco,
      },
      {
        key: 'deposito',
        value: deposito,
      },
      {
        key: 'rua',
        value: rua,
      },
      {
        key: 'predio',
        value: predio,
      },

      {
        key: 'nivel',
        value: nivel,
      },
      {
        key: 'tipoender',
        value: tipoender,
      },
      {
        key: 'apto',
        value: apto,
      },
      {
        key: 'situacao',
        value: situacao,
      },
    ])

    const response = await apinode.get(urlParams)

    return response.data
  }

  async getProductsOnAddress(codendereco) {
    const response = await apinode.get(
      `/wmsAddress/check/${codendereco}/${this.idconta}`,
    )

    return response.data
  }

  async getByCodendereco(codendereco) {
    const response = await apinode.get(
      `/wmsAddress/${codendereco}/${this.idconta}`,
    )

    return response.data
  }

  async create(data) {
    const response = await apinode.post(`/wmsAddress/${this.idconta}`, { data })

    return response.data
  }

  async update(codendereco, data) {
    await apinode.put(`/wmsAddress/${codendereco}/${this.idconta}`, {
      data,
    })
  }

  async transferAddresses(addresses) {
    await apinode.put(`/wmsAddress/transfer/${this.idconta}`, {
      addresses,
    })
  }

  async delete(codendereco) {
    await apinode.delete(`/wmsAddress/${codendereco}/${this.idconta}`)
  }
}

export default new WmsProductService()
